import { Column, Grid } from "@carbon/react";
import { CurrencyDisplay } from "../../../../components";

export const View = ({
  title,
  // subtitle,
  navigateButton,
  data,
  total,
  totalCurrencySymbol,
}) => {
  return (
    <Column className="balance--container">
      <div className="flex-container header-container">
        <h5 className="flex-box header--title">{title}</h5>

        {navigateButton && navigateButton}
      </div>

      <Grid className="grid">
        {data.map((item) => (
          <Column sm={4} md={8} lg={16}>
            <div className="flex-container">
              <small className="flex-box color-light">{item.description}</small>

              <CurrencyDisplay
                amount={item.amount}
                currencySymbol={item.currencySymbol}
                fontSize={14}
              />
            </div>
          </Column>
        ))}
      </Grid>

      <div className="flex-container total font-ctm--semibold">
        <div className="flex-box">
          <h6>Total</h6>
        </div>

        <h5>
          <CurrencyDisplay
            currencySymbol={totalCurrencySymbol}
            amount={total}
            fontSize={14}
            amountClassName="font-ctm--bold"
          />
        </h5>
      </div>
    </Column>
  );
};
